/**
 * simplex controller
 */

import {factories} from '@strapi/strapi'

export default factories.createCoreController('plugin::telegram-bot.telegram-user-activity', {
  getUserActivity: async (ctx, next) => {
    const {groupId, telegramId} = ctx.params;
    const data = await strapi.plugin('telegram-bot').service('telegram-user-activity').getActivity(groupId, telegramId);

    if (!data) {
      ctx.body = {
        success: false,
      }
    } else {
      ctx.body = {
        success: true,
        data
      }
    }

  }
});
